// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: true,
  IMAGE_PATH:"https://apis.oqsie.net/oqsie_apis/",
  SERVER_URL : "https://apis.oqsie.net:3008",
  PROFILE_IMAGE_PATH: "https://apis.oqsie.net/oqsie_apis/public/consultant_profile/",  
  category_images: "https://apis.oqsie.net/oqsie_apis/public/category_images/",
};
